import React from "react";
import Helper from "../functions/Helper.js"
import Rollbar from "rollbar";


export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    if(process.env.NODE_ENV !== 'development'){
      this.rollbar= new Rollbar({
         accessToken: '207b0cae5369443a8c604ffb6bc80e2b',
         payload: {
          environment: "Shoe Reviews Frontend Web",
          client: {
           javascript: {
             source_map_enabled: true,
             code_version: __COMMIT_HASH__,
             guess_uncaught_frames: true
           }
         }
        }
      });
    }

    this.state = { hasError: false };
  }


  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    Helper.gaEvent("error","shoe-reviews",error);
    if(process.env.NODE_ENV !== 'development'){
      this.rollbar.error(error);
    }
  }

  render() {
    if (this.state.hasError) {
      return(
        <div>
          <h1>Something went wrong.</h1>
          <div>Try refreshing the browser</div>
        </div>
    );
  }

    return this.props.children;
  }
}
